module.exports = __webpack_public_path__ + "img/5.655f07b6.jpg";